module.exports = __webpack_public_path__ + "img/bb.ab9f60e0.png";